var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.318,
    height: 41.348,
    viewBox: "0 0 42.318 41.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7e2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5ad52"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850",
    transform: "translate(10 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4819",
    "data-name": "Group 4819",
    transform: "translate(-10 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M-1.223,528.18c0,.126,0,.252,0,.377q-.194,13.022-.389,26.044a20.771,20.771,0,0,0,8.23-13.492,20.771,20.771,0,0,0-3.8-15.34,20.529,20.529,0,0,1,7.141,16.773,18.79,18.79,0,0,1-9.9,15.145,15.806,15.806,0,0,0,9.176,1.1A17.2,17.2,0,0,1-.9,559.97a1.323,1.323,0,0,0-.737,0,1.271,1.271,0,0,0-.455.384l-1.727,2-1.537-1.794a1.836,1.836,0,0,0-.607-.527,1.949,1.949,0,0,0-1.121-.013,16.915,16.915,0,0,1-9.794-1.233A15.537,15.537,0,0,0-7.7,557.665a18.435,18.435,0,0,1-9.635-13.072,20.516,20.516,0,0,1,3.965-15.869,12.916,12.916,0,0,1,2.726-2.739,21.93,21.93,0,0,0-3.609,15.289A19.5,19.5,0,0,0-6.005,554.53L-6.422,528a3.112,3.112,0,0,1,.4-1.945,3.169,3.169,0,0,1,1.09-.8,5.952,5.952,0,0,0,.613-.361c.164-.117.374-.416.549-.416s.529.306.678.4a6.7,6.7,0,0,1,.641.452,3.238,3.238,0,0,1,.977,1.222A4.144,4.144,0,0,1-1.223,528.18Z",
    transform: "translate(24.984 -521.006)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M-141.317,552.584a16.035,16.035,0,0,1,.286-3.325,16.871,16.871,0,0,1,3.979-7.932,17.393,17.393,0,0,1,3.421-2.967,16.582,16.582,0,0,1,1.972-1.116c.536-.256,1.442-.82,2.041-.715-.155.486-1.039,1-1.429,1.375a20.949,20.949,0,0,0-1.467,1.555,21.531,21.531,0,0,0-2.433,3.512,21.218,21.218,0,0,0-2.569,8.1,21.4,21.4,0,0,0,4.691,15.574,4.87,4.87,0,0,1-2.425-1.244A17.223,17.223,0,0,1-141.317,552.584Z",
    transform: "translate(141.319 -532.329)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M387,552.369a17.237,17.237,0,0,1-5.441,12.283,6.59,6.59,0,0,1-3.053,1.767,21.164,21.164,0,0,0-2.638-29.546c-.119-.1-.62-.379-.424-.568.14-.135.674.161.831.224a16.219,16.219,0,0,1,1.691.781,17.079,17.079,0,0,1,3.072,2.1,17.439,17.439,0,0,1,4.479,5.9A15.964,15.964,0,0,1,387,552.369Z",
    transform: "translate(-344.68 -532.098)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M132.977,469.7a3.128,3.128,0,0,1-2.1-.864,3.1,3.1,0,0,1-5.3-2.294c.033-.852.831.176,1.113.4a3.3,3.3,0,0,0,3.844.13.728.728,0,0,1,.253-.136.686.686,0,0,1,.452.128,3.978,3.978,0,0,0,2.686.561,3.713,3.713,0,0,0,2.136-1.552,3.163,3.163,0,0,1-1.578,3.281A3.027,3.027,0,0,1,132.977,469.7Z",
    transform: "translate(-109.706 -466.078)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.94a4446af3b7f8252bba0b57bccb5953.svg";
export { ForwardRef as ReactComponent };